import { AxiosError } from 'axios'

export interface RequestError extends AxiosError<any> {
  non_field_errors: string[]
}

export interface HandleAxiosErrorsConfiguration {
  excludeFields?: string[]
  nonFieldErrorsAs?: string
  showGlobalError?: boolean
}

export const useHandleAxiosFormErrors = () => {
  const initialConfiguration: HandleAxiosErrorsConfiguration = { excludeFields: [], showGlobalError: true }

  return (
    error: RequestError,
    setErrors: any,
    configuration: HandleAxiosErrorsConfiguration = initialConfiguration,
  ) => {
    if (!configuration.excludeFields) {
      configuration.excludeFields = []
    }
    if (configuration.nonFieldErrorsAs) {
      configuration.excludeFields.push('non_field_errors')
    }
    if (error.response?.status === 400 || error.response?.status === 403) {
      if (error.response.data.non_field_errors) {
        const errorMessages = error.response.data.non_field_errors
        setErrors(configuration.nonFieldErrorsAs, {
          type: 'server',
          message: Array.isArray(errorMessages) ? errorMessages.join('. ') : errorMessages,
        })
      }

      Object.keys(error.response.data).map(key => {
        if (!configuration.excludeFields?.includes(key)) {
          const message = error.response?.data[key]
          if (typeof message[0] === 'object') {
            handleAxiosFormErrorsNestedObject(key, message, setErrors)
          } else {
            setErrors(key, {
              type: 'server',
              message: (message || []).join('. '),
            })
          }
        }
      })
    }
  }
}

const handleAxiosFormErrorsNestedObject = (fieldName, message, setErrors) => {
  message.map((validation, index) => {
    Object.keys(validation).map(key => {
      const newKey = `${fieldName}.${index}.${key}`
      setErrors(newKey, {
        type: 'server',
        message: validation[key].join('. '),
      })
    })
  })
}
